const IconExclamationTriangle = () => (
  <svg width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_5153_19348)">
      <path
        d="M19.6352 3.18303C19.1894 2.41179 18.3915 1.9502 17.4999 1.9502C16.6082 1.9502 15.8104 2.41179 15.3638 3.18389L15.3646 3.18309L0.834439 28.3515C0.388653 29.1227 0.388653 30.0442 0.833642 30.8163C1.27943 31.5884 2.0773 32.05 2.96893 32.05H32.031C32.9226 32.05 33.7204 31.5884 34.1663 30.8163C34.6112 30.0442 34.6112 29.1227 34.1663 28.3515L19.6352 3.18303ZM17.4999 27.2016C16.5609 27.2016 15.7996 26.4404 15.7996 25.5014C15.7996 24.5624 16.5609 23.8011 17.4999 23.8011C18.4389 23.8011 19.2001 24.5624 19.2001 25.5014C19.2001 26.4404 18.4389 27.2016 17.4999 27.2016ZM19.2001 18.9967C19.2001 19.9357 18.4389 20.697 17.4999 20.697C16.5609 20.697 15.7996 19.9357 15.7996 18.9967V10.6657C15.7996 9.7267 16.5609 8.96542 17.4999 8.96542C18.4389 8.96542 19.2001 9.7267 19.2001 10.6657V18.9967Z"
        fill="url(#paint0_linear_5153_19348)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_5153_19348"
        x1="17.5"
        y1="1.9502"
        x2="17.5"
        y2="32.05"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF9473" />
        <stop offset="1" stop-color="#FF9473" />
      </linearGradient>
      <clipPath id="clip0_5153_19348">
        <rect width="34" height="34" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

type EmergingRiskFactorProps = {
  riskFactorName: string;
  riskFactorSubtext: string;
};

export const EmergingRiskFactor = ({ riskFactorName, riskFactorSubtext }: EmergingRiskFactorProps) => {
  return (
    <div className="relative box-border flex w-full max-w-sm flex-col items-center gap-[10px] overflow-clip rounded-[16px] bg-[rgba(255,255,255,0.09)] px-0 pt-0 pb-[40px] shadow-[0px_20px_24px_-4px_rgba(10,13,18,0.1),0px_8px_8px_-4px_rgba(10,13,18,0.04)]">
      <div className="relative box-border flex w-full flex-col items-center gap-[20px] px-[16px] pt-[20px] pb-0">
        <div className="relative flex flex-col items-center gap-[8px]">
          <div className="relative h-[34px] w-[34px] shrink-0">
            <IconExclamationTriangle />
          </div>
          <div className="relative flex items-center justify-center gap-[10px]">
            <div className="relative flex items-start rounded-[100px]">
              <div className="relative box-border flex h-[21px] items-center justify-center gap-[5px] rounded-[4px] border border-solid border-[#ff9473] bg-[#ff9473] p-[5px]">
                <p className="text-center text-[12px] leading-[1.3] font-semibold whitespace-nowrap text-[#183344]">
                  Emerging Risk Factor
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="relative flex w-full flex-col items-center">
        <div className="relative box-border flex w-full flex-col items-center gap-[12px] px-[16px] pt-[5px] pb-0">
          <div className="flex w-full flex-col items-center gap-[4px] text-center text-white">
            <p className="w-full text-[20px] leading-[1.3] font-bold">{riskFactorName}</p>
            <p className="w-full text-[14px] leading-[1.4] font-normal">{riskFactorSubtext}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
